import React from 'react';
import './RestartPlanChurned.css';
import { getFormattedDate } from 'Utils/Format';
import { getSimplifiedPlanDisplayName } from 'Utils/Plans';

export const RestartPlanChurned = ({ restartPlan, churnedPlan }) => {
  const date = new Date(churnedPlan.validityTill);
  const planExpiration = getFormattedDate(date.toISOString());
  return (
    <div className="restartChurnedUserDetails">
      <div className="restartHeader">{getSimplifiedPlanDisplayName(restartPlan)}</div>
      <div className="restartMessage">
        Your plan ended on {planExpiration}. Click on "Resubscribe” to start your Fox Nation subscription again.
      </div>
    </div>
  );
};
